export default "__VITE_ASSET__d50d7a23__"